import mapboxgl from 'mapbox-gl';
import jstree from 'jstree';
import gsap from 'gsap';
import Cookies from 'js-cookie';

var Offices = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-Offices',
	};

	$.extend(true, this.options, options);

};

Offices.prototype.init = function() {

	var self = this;

	this.$dropdownFilterHeadings = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter__heading`);
	this.$filterWrappers = this.options.$el.find(`.${self.options.baseClass}__dropdownFilterWrapper`);
	this.$locationFilter = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter--location .${self.options.baseClass}__dropdownFilter__filter`);
	this.$clearFiltersButton = this.options.$el.find(`.${self.options.baseClass}__clearFiltersButton`);
	this.$mapContainer = this.options.$el.find(`.${self.options.baseClass}__mapContainer`);

	this.branchData = null;

	this.initMap();
	this.initFilters();

	let currentRegion = Cookies.get('region');

	if (currentRegion) {

		currentRegion = currentRegion.replace('+', ' ');

		// there is a region set, so start the map there
		let $currentRegionFilterNode = self.options.$el.find(`[data-region="${currentRegion}"]`)
		this.$locationFilter.jstree('select_node', $currentRegionFilterNode);
	}

};

Offices.prototype.initMap = function() {

	var self = this;

	mapboxgl.accessToken = 'pk.eyJ1IjoiYXV0aGVudGljZmYiLCJhIjoiUmtjWTY2byJ9.QeHZuWdaMRJlobq_RgXngw';

	// map defaults
	this.center = [-74.50, 40];
	this.zoom = 1;

	this.map = new mapboxgl.Map({
		container: self.$mapContainer[0],
		style: 'mapbox://styles/authenticff/cjt3iorem2sc21fo8an3p33v3',
		dragPan: true,
		center: this.center,
		zoom: this.zoom,
		minZoom: 0
	});

	this.map.addControl(new mapboxgl.NavigationControl(), 'bottom-right');
	this.map.scrollZoom.disable();

	this.map.on('style.load', function () {
		self.initBranchData();
	});

};

Offices.prototype.initBranchData = function(){

	var self = this;

	// Cities
	return $.ajax({
		url: '/branches.json',
		type: 'GET',
		data: {
			useGeoJson: true,
			language: "english"
		},
		dataType: 'json'
	})
	.done(function(data) {

		var branchGeoJson = {
			"type": "FeatureCollection",
			"features": data.data
		};

		console.log(branchGeoJson);

		self.branchData = branchGeoJson;

		self.addMarkers();

		self.updateMarkers();

	});

};

Offices.prototype.addMarkers = function() {

	var self = this;

	// add it to the map
	this.map.addSource('branches', {
		type: 'geojson', data: self.branchData,
		cluster: true,
		clusterMaxZoom: 14, // Max zoom to cluster points on
		clusterRadius: 25 // Radius of each cluster when clustering points (defaults to 50)
	});

	this.map.addLayer({
		id: "clusters",
		type: "circle",
		source: "branches",
		filter: ["has", "point_count"],
		paint: {
			"circle-color": "#60717a",
			"circle-radius": 20,
			"circle-stroke-width": 4,
			"circle-stroke-color": "#aac2da"
		}
	});

	this.map.addLayer({
		id: "cluster-count",
		type: "symbol",
		source: "branches",
		filter: ["has", "point_count"],
		layout: {
			"text-field": "{point_count_abbreviated}",
			"text-font": ["Roboto-Condensed", "Arial Unicode MS Bold"],
			"text-size": 12,
			"text-allow-overlap" : true
		},
		paint: {
			"text-color": "#ffffff"
		}
	});


	this.map.addLayer({
		id: "unclustered-point",
		type: "circle",
		source: "branches",
		filter: ["!", ["has", "point_count"]],
		paint: {
			"circle-color": "#4fa9df",
			"circle-radius": 6,
			"circle-stroke-width": 1,
			"circle-stroke-color": "#fff"
		}
	});

	// inspect a cluster on click
	this.map.on('click', 'clusters', function(e) {

		var features = self.map.queryRenderedFeatures(e.point, {
			layers: ['clusters']
		});

		var clusterId = features[0].properties.cluster_id;

		self.map.getSource('branches').getClusterExpansionZoom(clusterId, function(err, zoom) {
			if (err)
				return;

			self.map.flyTo({
				center: features[0].geometry.coordinates,
				zoom: zoom
			});
		});

	});

	// Create a popup, but don't add it to the map yet.
	var popup = new mapboxgl.Popup({
		closeButton: true,
		closeOnClick: true
	});

	this.map.on('click', 'unclustered-point', function(e) {

		// Change the cursor style as a UI indicator.
		self.map.getCanvas().style.cursor = 'pointer';

		var coordinates = e.features[0].geometry.coordinates.slice();
		var markerHtml = self.buildMarker(e.features[0].properties);

		// Ensure that if the map is zoomed out such that multiple
		// copies of the feature are visible, the popup appears
		// over the copy being pointed to.
		while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
			coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
		}

		// Populate the popup and set its coordinates
		// based on the feature found.
		popup.setLngLat(coordinates)
			.setHTML(markerHtml)
			.addTo(self.map);

	});

};

Offices.prototype.updateMarkers = function() {

	var self = this;

	let unfilteredGeoJson = this.branchData;
	let filteredGeoJson = this.getFilteredGeoJson(unfilteredGeoJson);

	if (filteredGeoJson.features.length) {

		self.map.getSource('branches').setData(filteredGeoJson);

		let paddingArray = {top: 100, bottom: 100, left: 200, right: 200};

		if (window.Breakpoint.value == 'xsmall') {
			paddingArray = {top: 20, bottom: 20, left: 20, right: 20};
		}
		else if (window.Breakpoint.value == 'small') {
			paddingArray = {top: 20, bottom: 20, left: 32, right: 32};
		}

		// getting our bounding box
		let bounds = new mapboxgl.LngLatBounds();
		filteredGeoJson.features.forEach(function(feature) {
			bounds.extend(feature.geometry.coordinates);
		});

		self.map.fitBounds(bounds, {
			padding: paddingArray,
			maxZoom: 10
		});

	}

};

Offices.prototype.getFilteredGeoJson = function(unfilteredGeoJson) {

	var self = this;

	let filteredFeatures = [];

	// location filters
	let selectedLocationFilters = this.$locationFilter.jstree('get_bottom_checked');
	let selectedBranchIds = [];

	if (selectedLocationFilters.length > 0) {

		for (let i = 0; i < selectedLocationFilters.length; i++) {
			let $node = self.$locationFilter.jstree('get_node', selectedLocationFilters[i]);
			selectedBranchIds = [...new Set([...selectedBranchIds,...$node.data.branches])]; // filter out duplicates
		}

		$.each(unfilteredGeoJson.features, function(){

			let feature = this;

			if (selectedBranchIds.includes(feature.properties.id.toString())) {
				filteredFeatures.push(feature);
			}

		});

	}
	else {
		console.log('no selections');
		filteredFeatures = unfilteredGeoJson.features;
	}

	// Creating a new unique set of GeoJson Features to pass to the map
	let filteredBranchGeoJson = _.clone(unfilteredGeoJson);
	filteredBranchGeoJson.features = filteredFeatures;

	return filteredBranchGeoJson;

};

Offices.prototype.buildMarker = function(propertiesObj) {

	var self = this;

	if(propertiesObj.branch_location_format == "city"){

		return `
			<div class="${self.options.baseClass}__mapPopup">
				<span class="${self.options.baseClass}__mapPopup__title">${propertiesObj.title}</span>
				<span class="${self.options.baseClass}__mapPopup__address">${propertiesObj.branch_address1}</span>
				<span class="${self.options.baseClass}__mapPopup__cityState">${propertiesObj.branch_city}</span>
				<span class="${self.options.baseClass}__mapPopup__phone">${propertiesObj.branch_phone}</span>
				<a class="${self.options.baseClass}__mapPopup__contactName" href=${propertiesObj.branch_contact_url}>${propertiesObj.branch_contact_name}</a>
				<span class="${self.options.baseClass}__mapPopup__contactEmail">${propertiesObj.branch_contact_email}</span>
				<a class="${self.options.baseClass}__mapPopup__branchEmail" href="mailto:${propertiesObj.branch_email}">${propertiesObj.branch_email}</a>
			</div>
		`;

	}else if(propertiesObj.branch_location_format == "cityCountry"){

		return `
			<div class="${self.options.baseClass}__mapPopup">
				<span class="${self.options.baseClass}__mapPopup__title">${propertiesObj.title}</span>
				<span class="${self.options.baseClass}__mapPopup__address">${propertiesObj.branch_address1}</span>
				<span class="${self.options.baseClass}__mapPopup__cityState">${propertiesObj.branch_city + ", "}${propertiesObj.branch_country}</span>
				<span class="${self.options.baseClass}__mapPopup__phone">${propertiesObj.branch_phone}</span>
				<a class="${self.options.baseClass}__mapPopup__contactName" href=${propertiesObj.branch_contact_url}>${propertiesObj.branch_contact_name}</a>
				<span class="${self.options.baseClass}__mapPopup__contactEmail">${propertiesObj.branch_contact_email}</span>
				<a class="${self.options.baseClass}__mapPopup__branchEmail" href="mailto:${propertiesObj.branch_email}">${propertiesObj.branch_email}</a>
			</div>
		`;

	}else if(propertiesObj.branch_location_format == "stateCountry"){

		return `
			<div class="${self.options.baseClass}__mapPopup">
				<span class="${self.options.baseClass}__mapPopup__title">${propertiesObj.title}</span>
				<span class="${self.options.baseClass}__mapPopup__address">${propertiesObj.branch_address1}</span>
				<span class="${self.options.baseClass}__mapPopup__cityState">${propertiesObj.branch_state + ", "}${propertiesObj.branch_country}</span>
				<span class="${self.options.baseClass}__mapPopup__phone">${propertiesObj.branch_phone}</span>
				<a class="${self.options.baseClass}__mapPopup__contactName" href=${propertiesObj.branch_contact_url}>${propertiesObj.branch_contact_name}</a>
				<span class="${self.options.baseClass}__mapPopup__contactEmail">${propertiesObj.branch_contact_email}</span>
				<a class="${self.options.baseClass}__mapPopup__branchEmail" href="mailto:${propertiesObj.branch_email}">${propertiesObj.branch_email}</a>
			</div>
		`;

	}else{

		return `
			<div class="${self.options.baseClass}__mapPopup">
				<span class="${self.options.baseClass}__mapPopup__title">${propertiesObj.title}</span>
				<span class="${self.options.baseClass}__mapPopup__address">${propertiesObj.branch_address1}</span>
				<span class="${self.options.baseClass}__mapPopup__cityState">${propertiesObj.branch_city + ", "}${propertiesObj.branch_state}</span>
				<span class="${self.options.baseClass}__mapPopup__phone">${propertiesObj.branch_phone}</span>
				<a class="${self.options.baseClass}__mapPopup__contactName" href=${propertiesObj.branch_contact_url}>${propertiesObj.branch_contact_name}</a>
				<span class="${self.options.baseClass}__mapPopup__contactEmail">${propertiesObj.branch_contact_email}</span>
				<a class="${self.options.baseClass}__mapPopup__branchEmail" href="mailto:${propertiesObj.branch_email}">${propertiesObj.branch_email}</a>
			</div>
		`;

	}

};

Offices.prototype.initFilters = function() {

	var self = this;

	this.$locationFilter.jstree({
		"core": {
			"themes": {
				"icons": false
			}
		},
		"checkbox" : {
			// cascade: 'down'
			// "keep_selected_style" : false
		},
		"plugins" : [ "checkbox", "sort" ]
	});

	// when a dropdown filter heading is clicked
	this.$dropdownFilterHeadings.on('click', function() {

		let $dropdownFilter = $(this).closest(`.${self.options.baseClass}__dropdownFilter`);

		if ($dropdownFilter.hasClass(`${self.options.baseClass}__dropdownFilter--active`))
		{
			self.closeDropdownFilter($dropdownFilter);
		}
		else
		{
			self.openDropdownFilter($dropdownFilter);
		}

	});

	this.$locationFilter.on('changed.jstree', function(e, data) {

		let $filterParent = $(this).closest(`.${self.options.baseClass}__dropdownFilter`);
		let selectedClass = `${self.options.baseClass}__dropdownFilter--selected`;

		if (data.selected.length) {
			$filterParent.addClass(selectedClass);
		}
		else {
			$filterParent.removeClass(selectedClass);
		}

		self.updateMarkers();

	});

	// when the clear filters button is clicked
	this.$clearFiltersButton.on('click', function() {
		self.clearAllFilters();
		self.updateMarkers();
	});

	// when clicking outside the filters, close them
	$(`body`).on('click', function() {

		if(window.Breakpoint.value != "xsmall" && window.Breakpoint.value != "small"){
			self.closeAllDropdownFilters();
		}

	});

	// when clicking a filter, don't close the filters
	this.$filterWrappers.on('click', function(e) {
		e.stopPropagation();
	});

};

Offices.prototype.clearAllFilters = function() {

	var self = this;

	this.$locationFilter.jstree('deselect_all');

};

Offices.prototype.openDropdownFilter = function($dropdownFilter) {

	var self = this;

	let $filterWrapper = $dropdownFilter.find(`.${self.options.baseClass}__dropdownFilter__filterWrapper`);

	$dropdownFilter.addClass(`${self.options.baseClass}__dropdownFilter--active`);

	gsap.timeline()
	.set($filterWrapper, {
		overflow: 'hidden'
	})
	.to($filterWrapper, {
		height: 'auto',
		duration: 0.5,
	})
	.set($filterWrapper, {
		overflow: 'auto'
	});

};

Offices.prototype.closeAllDropdownFilters = function() {

	var self = this;

	this.options.$el.find(`.${self.options.baseClass}__dropdownFilter`).each(function() {

		self.closeDropdownFilter($(this));

	});

};

Offices.prototype.closeDropdownFilter = function($dropdownFilter) {

	var self = this;

	let $filterWrapper = $dropdownFilter.find(`.${self.options.baseClass}__dropdownFilter__filterWrapper`);

	$dropdownFilter.removeClass(`${self.options.baseClass}__dropdownFilter--active`);

	gsap.timeline()
	.set($filterWrapper, {
		overflow: 'hidden'
	})
	.to($filterWrapper, {
		height: 0,
		duration: 0.35,
	})
	.set($filterWrapper, {
		overflow: 'auto'
	});

};

export default Offices;
